import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  line-height: 1;
  white-space: pre-wrap;
  z-index: -1;
  opacity: 0;
  background: transparent;
  color: transparent;
  outline: none;
  caret-color: transparent;
  will-change: left, top;
  contain: strict;

  textarea {
    font-size: inherit;
    line-height: 1;
    padding: 0;
    border: none;
    white-space: nowrap;
    width: 1em;
  }
`;
